/**
 * Any screen can ask for the Google sign-in without owning it: the app listens and starts it
 * (App.tsx `handleAuthentication`). Used where signing in is the next step, such as a guest's Context.
 */
const SIGN_IN_REQUESTED = 'minimany:sign-in-requested'

export function requestSignIn(): void { window.dispatchEvent(new Event(SIGN_IN_REQUESTED)) }

export function onSignInRequested(handler: () => void): () => void {
  window.addEventListener(SIGN_IN_REQUESTED, handler)
  return () => window.removeEventListener(SIGN_IN_REQUESTED, handler)
}
